














































import WrappedLink from '@components/WrappedLink.vue'
import { SimpleContent, SearchCard } from '@/types/content'
import Card from '@components/BookmarkCard.vue'
import get from 'lodash/get'
import eventTracker from '@/utils/eventTracker'
import wrappers from '@/mixins/wrappers'
import mixins from 'vue-typed-mixins'
export default mixins(wrappers).extend({
  name: 'LearningBookmarks',
  props: {
    q: String
  },
  data () {
    return {
      searchTerm: this.q,
      loading: true
    }
  },
  components: {
    Card,
    WrappedLink
  },
  async beforeRouteLeave (to, from, next) {
    await this.$store.dispatch('user/content/SetSearchBarVisibility', false)
    next()
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        refresh: this.offlineWrapper(this.refresh)
      }
    },
    containerStyle (): Record<string, string> {
      return {
        marginTop: `${32 + (this.$store.getters['user/content/searchBarVisible'] ? 72 : 0)}px`
      }
    },
    results (): SearchCard[] {
      return this.$store.getters['user/content/searchResults'].map(
        (searchItem: SimpleContent) => {
          const category = get(searchItem, 'category', '')
          const title = get(searchItem, 'title', '')
          const description = get(searchItem, 'content', '')
          const imageUrl = get(searchItem, 'imgUrl') || 'https://via.placeholder.com/200'
          const contentId = get(searchItem, 'id')
          return {
            category, title, description, imageUrl, contentId
          }
        }
      )
    }
  },
  methods: {
    cardClicked ({ contentId, title: contentTitle }: SearchCard) {
      eventTracker.track('LearnSearch contentChosen', { contentId, contentTitle })
    },
    async refresh () {
      this.loading = true
      try {
        await this.$store.dispatch('user/content/GetSearchResults', this.q)
        this.searchTerm = this.q
      }
      finally {
        this.loading = false
      }
    }
  },
  watch: {
    q: {
      handler () {
        this.wrapped.refresh()
      },
      immediate: true
    }
  }
})
